import { Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { DateRanges } from '@models/ranges';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonShared } from 'app/shared/classes/common';
import { ImportLogs, ImportLogsSearchCriteria, ImportSchedule } from '@models';
import { ImportService } from '@services/import.service';

interface DateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface ImportLogsModalParams {
  importSchedule: ImportSchedule;
}

@Component({
  standalone: false,
  selector: 'import-logs-modal',
  templateUrl: './import-logs-modal.component.html',
  styleUrls: ['./import-logs-modal.component.scss']
})

export class ImportLogsModalComponent implements OnInit, ImportLogsModalParams {

  common = new CommonShared();
  modalDragOn: boolean = false;
  importSchedule: ImportSchedule;
  importLogs: ImportLogs[] = [];
  exportName: string = 'ImportLogs.csv';

  public importLogCols = [
    {field: 'createdDate', header: 'Date', width: '25%'},
    {field: 'message', header: 'Message', width: '75%'}
  ];

  screenInnerWidth: number;
  selectedDateRange: DateRange = { startDate: moment(), endDate: moment() };
  ranges = DateRanges;

  public invalidDates: moment.Moment[] = [];


  constructor(
    public bsModalRef: BsModalRef, private toastr: ToastrService, private importService: ImportService) { }


  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.screenInnerWidth = window.innerWidth;
  }


  ngOnInit(): void {
    this.screenInnerWidth = window.innerWidth;
    this.datesUpdated('Today');
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }

  
  isInvalidDate = (m: moment.Moment) => this.invalidDates.some(d => d.isSame(m, 'day'));

  datesUpdated(quickPick: string): void {
    if (quickPick === 'Today') {
      this.selectedDateRange = { startDate: moment().startOf('day'), endDate: moment().endOf('day') };
    } else if (quickPick === 'Last 2 Days') {
      this.selectedDateRange = { startDate: moment().startOf('day').subtract(1, 'days'), endDate: moment().endOf('day') };
    } else if (quickPick === 'Last 7 Days') {
      this.selectedDateRange = { startDate: moment().startOf('day').subtract(6, 'days'), endDate: moment().endOf('day') };
    }

    if (this.selectedDateRange.startDate != null && this.selectedDateRange.endDate != null) {
      this.getImportLogs(this.importSchedule);
    }
  }

  private getImportLogs(importSchedule: ImportSchedule): void {
    var importLogsCriteria: ImportLogsSearchCriteria = {
      importScheduleId: importSchedule.id,
      startDate: this.selectedDateRange.startDate.local().toDate(),
      endDate: this.selectedDateRange.endDate.local().toDate()
    }

    this.importService.getImportLogs(importLogsCriteria).subscribe(
      results => {
        if (results != null) {
          this.importLogs = results;
          this.importLogs.forEach(log => {
            log.createdDate = moment.utc(log.createdDate).toDate();
          });
        }
        else {
          this.toastr.warning('No import logs found for ' + this.importSchedule.name);
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving import logs for ' + this.importSchedule.name);
      });
  }


}
